module.exports = __webpack_public_path__ + "img/line.356d5845.svg";